export default {
  "app-layout": () => import("/home/forge/app.inaia.uk/layouts/AppLayout.vue").then(m => m.default || m),
  "outside-layout": () => import("/home/forge/app.inaia.uk/layouts/OutsideLayout.vue").then(m => m.default || m)
}